/* eslint-disable no-undef */

import React from 'react'

import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { scroller, Element } from 'react-scroll'

import homepin from '@kolayyolla/common/images/pin_home.svg'
import pinpoint from '@kolayyolla/common/images/pin_venue.svg'

import Map from '@kolayyolla/shared/Map'

import { MapOutlined, Search, ViewAgendaOutlined } from '@mui/icons-material'
import { Avatar, IconButton, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { TOP_BAR_HEIGHT } from '../../constants/sizes'

import CardSkelaton from './CardSkelaton'
import HorizontalFilters from './HorizontalFilters'
import VenueCard from './VenueCard'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '450px 1fr',
    gridTemplateAreas: '"venues map"',
    gridTemplateRows: '1fr'
  },
  venuesCol: {
    gridArea: 'venues',
    padding: theme.spacing(0.5, 1.5, 0.5, 0.5),
    height: 'calc(100vh - 50px)',
    overflowY: 'scroll',
    overflowX: 'hidden',

    '&::-webkit-scrollbar': {
      width: 13
    },
    '&::-webkit-scrollbar-track': {
      background: '#ffffff'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#9d9a9e',
      borderRadius: 13,
      border: '3px solid #ffffff'
    }
  },
  mapCol: {
    gridArea: 'map'
  },
  empty: {
    display: 'flex',
    height: 'calc(100vh - 150px)'
  },
  headerBottom: {
    display: 'flex',
    backgroundColor: '#fafafa',
    flexDirection: 'row',
    alignItems: 'space-around',
    justifyContent: 'space-between',
    margin: theme.spacing(0, -1, -2, 1),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    [theme.breakpoints.only('xs')]: {
      margin: theme.spacing(1, 1, -1, 1)
    }
  },
  primaryColor: {
    color: theme.palette.primary.main
  }

}))

const LocationsMap = ({ point, venues }) => {
  const classes       = useStyles()
  const navigate      = useNavigate()
  const venuesLoading = useSelector((state) => state.venues.isLoading)

  const [hoveredVenue, setHoveredVenue] = React.useState(null)

  const onMount = (point, venues) => (map) => {
    map.eachLayer(layer => {
      if (layer.options?.foo !== 'bar') {
        map.removeLayer(layer)
      }
    })

    map.createPane('homeMarker')
    map.getPane('homeMarker').style.zIndex = 999
    const homeMarker                       = L.marker(point.coord, {
      icon: L.icon({
        iconUrl: homepin,
        iconSize: [50, 50],
        iconAnchor: [25, 49],
        popupAnchor: [0, -49]
      }),
      pane: 'homeMarker'
    })

    homeMarker.bindPopup('<h4 >' + point.name + '</h4>')
    homeMarker.addTo(map)

    venues.forEach(p => {
    // map.zoomControl.remove()

      if (p?.coord?.lat) {
        const markerIcon = L.icon({
          iconUrl: pinpoint,
          iconSize: [40, 40],
          iconAnchor: [22, 39],
          popupAnchor: [0, -39]
        })

        const marker = L.marker(p.coord, {
          icon: markerIcon,
          venue: p._id,
          riseOnHover: true,
          riseOffset: 9999,
          opacity: p.canOrder ? 1 :  0.5
        }).addTo(map)

        // marker.bindTooltip(p.name, { offset: [-10, -40] })
        marker.bindPopup(`<h4>${p.name}</h4>`, { closeButton: false })

        if (hoveredVenue === p._id) {
          marker.openPopup()
        }

        marker.on('click', () => {
          scroller.scrollTo(p._id, {
            duration: 1000,
            delay: 50,
            smooth: true,
            containerId: 'venuesCol',
            offset: -50 // Scrolls to element + 50 pixels down the page
          })
        })
        marker.addEventListener('mouseover', (e) => {
          markerIcon.options.iconAnchor = [22, 49]
          markerIcon.options.iconSize   = [45, 45]
          marker.setIcon(markerIcon)
          marker.openPopup()
        })
        marker.addEventListener('mouseout', (e) => {
          markerIcon.options.iconAnchor = [22, 39]
          markerIcon.options.iconSize   = [40, 40]
          marker.setIcon(markerIcon)
          marker.openPopup()
        })
      }
    })
  }
  const mapProps = {
    options: {
      center: point?.coord,
      zoom: 14
    },
    style: { height: `calc(100vh - ${TOP_BAR_HEIGHT}px)` },
    onMount: onMount(point, venues)

  }

  const renderEmpty = () => (
    <div className={classes.empty}>
      <ListItem component="div">
        <ListItemAvatar>
          <Avatar>
            <Search />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Aradığınız kriterlere uygun bir işletme bulamadık" secondary="Filtreleri temizleyip yeniden deneyebilirsiniz." />
      </ListItem>
    </div>
  )
  return (
    <div className={classes.root}>
      <div className={classes.venuesCol} id="venuesCol">
        <HorizontalFilters />
        <div className={classes.headerBottom}>
          {
            venues.length > 0
              ? <Typography><strong className={classes.primaryColor}>{venues.length}</strong> tane işletme</Typography>
              : <Typography>...</Typography>
          }

          <div>
            <IconButton sx={{ padding: 0 }} onClick={() => { navigate({ hash: '' }) }} ><ViewAgendaOutlined color={'action' } /></IconButton>
            <IconButton sx={{ padding: 0 }}  ><MapOutlined color={'primary'}/></IconButton>
          </div>
        </div>

        {
          venuesLoading ? Array.from(Array(10).keys()).map((key) => <CardSkelaton key={key} fullWidth />)
            : venues.length > 0
              ? venues.map((v) => (
                <Element id={v._id} key={v._id} name={v._id}>
                  <VenueCard key={v._id} venue={v} fullWidth hoverable onMouseOver={() => setHoveredVenue(v._id)} />
                </Element>
              ))
              : renderEmpty()
        }

      </div>
      <div style={{
        gridArea: 'map'
      }}>
        <Map  {...mapProps} />

      </div>
    </div>)
}
export default LocationsMap
